import { FormControlLabel as MuiFormControlLabel, withStyles } from '@material-ui/core';

const FormControlLabel = withStyles((theme) => ({
  root: { margin: 0 },
  label: {
    fontSize: theme.typography.pxToRem(14),
    color: theme.colors.dark,
    lineHeight: 1.71,
  },
}))(MuiFormControlLabel);

export default FormControlLabel;
